export default {
      id: "ar_tourisme-usage",
      viewBox: "0 0 90 75",
      url: "../dist/images/" + "sprite.svg#ar_tourisme-usage",
      toString: function () {
        return this.url;
      }
    }